<template>
    <div style="padding: 10px; min-height: 200px; height: auto;">
        <div style="width: 100%; height: 36px; font-size: 16px; line-height: 36px;">
             <i class="el-icon-trophy" style="color: gold; font-size: 20px;"></i> 
             <span style="font-size: 16px; padding-left: 10px; font-weight: 600;">Rating排行榜</span>
        </div>
        <!-- 这里才是展示名字的地方 -->
        <div v-for="(t,index) in TheRankNum10" :key="index">
            <div style="width: 100%; font-size: 14px; margin-top: 8px;">
                <div v-if="index >= 0 && index <= 2">
                    <span style="padding-left: 4px; padding-right: 4px; background-color: gold; color: white;">{{index + 1}}</span>  
                    <span style="margin-left: 8px; color: red;"> {{t.name}} </span>
                    <span style="float: right; color: red;">{{ t.rating }}</span>
                </div>
                <div v-else-if="index >= 3 && index <= 4">
                    <span style="padding-left: 4px; padding-right: 4px;">{{index + 1}}</span>  
                    <span style="margin-left: 8px; color: red;"> {{t.name}} </span>
                    <span style="float: right; color: red;">{{ t.rating }}</span>
                </div>
                <div v-else>
                    <span style="padding-left: 4px; padding-right: 4px;">{{index + 1}}</span>  
                    <span style="margin-left: 8px; color: #FC7123;"> {{t.name}} </span>
                    <span style="float: right; color: #FC7123;">{{ t.rating }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Url from '@/constant/Url';
    import $ from "jquery"
    export default {
        name:'Rank',
        data() {
            return {
                TheRankNum10:[],
                isShow: false,
            }
        },
        mounted() {
            const vue = this

            $.ajax({
                url: Url.rAllRankUrl,
                type: "post",
                success(resp) {
                    if (resp.error_message === "success") {
                        vue.TheRankNum10 = JSON.parse(resp.list).slice(0, 10)

                        for ( let i = 0; i < 10 ; i ++ ) {
                            if (vue.TheRankNum10[i].name.length > 7) {
                                vue.TheRankNum10[i].name = vue.TheRankNum10[i].name.substr(0, 7) + "..."
                            }
                        }
                    }
                }
            })
        }
    }
</script>

<style scoped>

</style>